module.exports = __webpack_public_path__ + "img/2_37.1ac32767.png";